module.exports = __webpack_public_path__ + "static/img/c.e85d11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jeu2/img/c.png
// module id = EMpt
// module chunks = 0